export default "__VITE_PUBLIC_ASSET__65c97d93__"